module.exports = __webpack_public_path__ + "img/soh_event_small2.bf6dda7a.jpg";